import _ from 'lodash'

// test: jest src/utils/booking/__tests__/StaffDataFetcher.test.js
export default class StaffDataFetcher {
  constructor() {
    this._staffs = []
    this._isFetching = false
  }

  injectBookingPresetApi(apiClient) {
    this.injectedBookingPresetApi = apiClient
  }

  get isFetching() {
    return this._isFetching
  }

  get staffs() {
    return this._staffs
  }

  // deprecating, use fetchStaffsByBranch or fetchStaffsByServices
  async fetchAvailableStaffs(serviceIds, branchId, bookingPresetId) {
    if (!this.injectedBookingPresetApi) {
      throw new Error("booking preset API is not injected")
    }

    this._isFetching = true
    if (serviceIds === null || serviceIds.length === 0) {
      const response = await this.injectedBookingPresetApi.getStaffs(bookingPresetId, {
        branch_id: branchId
      })
      this._staffs = response.staffs
    } else {
      const staffsForEveryServices = await Promise.all(serviceIds.map(async (serviceId) => {
        const response = await this.injectedBookingPresetApi.getStaffs(bookingPresetId, {
          service_id: serviceId,
          branch_id: branchId
        })
        return response.staffs
      }))
      this._staffs = _.intersectionBy(...staffsForEveryServices, 'id')
    }
    this._isFetching = false
    return this._staffs
  }

  async fetchStaffsByBranch(branchId, bookingPresetId) {
    if (!this.injectedBookingPresetApi) {
      throw new Error("booking preset API is not injected")
    }

    if (!branchId) {
      console.warn('[StaffDataFetcher] branchId is not provided. Calling for fetchStaffsByBranch() is skipped.')
      this._staffs = []
      return []
    }

    this._isFetching = true
    const response = await this.injectedBookingPresetApi.getStaffs(bookingPresetId, {
      branch_id: branchId
    })
    this._staffs = response.staffs
    this._isFetching = false
    return this._staffs
  }

  async fetchStaffsByServices(serviceIds, branchId, bookingPresetId) {
    if (!this.injectedBookingPresetApi) {
      throw new Error("booking preset API is not injected")
    }

    if (!branchId) {
      console.warn('[StaffDataFetcher] branchId is not provided. Calling for fetchStaffsByServices() is skipped.')
      this._staffs = []
      return []
    }

    if (serviceIds.length === 0) {
      console.warn('[StaffDataFetcher] serviceIds is empty. Calling for fetchStaffsByServices() is skipped.')
      this._staffs = []
      return []
    }

    this._isFetching = true
    const staffsForEveryServices = await Promise.all(serviceIds.map(async (serviceId) => {
      const response = await this.injectedBookingPresetApi.getStaffs(bookingPresetId, {
        service_id: serviceId,
        branch_id: branchId
      })
      return response.staffs
    }))
    this._staffs = _.intersectionBy(...staffsForEveryServices, 'id')
    this._isFetching = false
    return this._staffs
  }
}
